import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs';

export function initializeTranslations(translateService: TranslateService): () => Promise<void> {
  return async (): Promise<void> => {
    const language = localStorage.getItem('sh-language') || (translateService.getBrowserLang() as string);
    return new Promise(resolve => {
      translateService.setDefaultLang(language);
      translateService
        .use(language)
        .pipe(take(1))
        .subscribe(() => resolve());
    });
  };
}
